@use '@lib/assets/styles/main.scss' as *;


.surface {
  overflow: hidden;
  position: relative;
  & > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
}

// Shapes
.circle {
  border-radius: 50%;
}

.rounded {
  border-radius: 12px;
}

.square {
  border-radius: 0;
}

// Sizes
.sm {
  width: 32px;
  height: 32px;
}

.md {
  width: 40px;
  height: 40px;
}

.lg {
  width: 48px;
  height: 48px;
}

// Color variants
// Palette variants aligned with Colors enum values
.aquamarine { color: $aquamarine; background-color: $aquamarineLight; }
.black { color: $gray1000; background-color: $gray100; }
.blue { color: $blue; background-color: $blueLight; }
.brown { color: $brown; background-color: $brownLight; }
.corral { color: $corral; background-color: $corralLight; }
.disabled { color: $disable500; background-color: $disable100; }
.filter { color: $blue; background-color: $blue50; }
.gray { color: $gray700; background-color: $gray100; }
.green { color: $green; background-color: $greenLight; }
.lime { color: $lime; background-color: $limeLight; }
.orange { color: $orange; background-color: $orangeLight; }
.pink { color: $pink; background-color: $pinkLight; }
.red { color: $red; background-color: $redLight; }
.violet { color: $violet; background-color: $violetLight; }
.white { color: $gray700; background-color: $gray0; }
.yellow { color: $yellow; background-color: $yellowLight; }

// Aliases for legacy names still used elsewhere
.warning { @extend .orange; }
.error { @extend .red; }
.neutral { @extend .gray; }
